import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import FilterSwatch from './FilterSwatch';

import { DESKTOP_START_QUERY } from '../../../styling/mixins/responsive';

const BackgroundContainer = styled.div`
  background-color: #fff;
`;

const SwatchGrid = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: left;
  padding: 1rem 1.5rem 0.25rem;
  max-width: 20rem;

  @media (min-width: 23rem) {
    padding: 1.5rem 2rem 0.25rem;
    max-width: 23rem;
  }

  @media (min-width: 48rem) {
    padding: 2rem 5rem 0.25rem;
    max-width: 32rem;
  }

  @media (${DESKTOP_START_QUERY}) {
    padding: 0;
    max-width: none;

    /** styles for open/close **/
    max-height: 10rem;
    transition: max-height 0.5s ease-in-out;
    overflow: hidden;

    &:hover {
      opacity: 0.5rem;
    }

    &.collapsed {
      max-height: 0;
    }
  }
`;

const FilterSwatchGrid = ({
  className,
  filterGroupData,
  isCollapsed = false,
}) => {
  return (
    <BackgroundContainer>
      <SwatchGrid className={`${className} ${isCollapsed ? 'collapsed' : ''}`}>
        {filterGroupData.values.map(filter => {
          return (
            <FilterSwatch
              key={filter.name}
              value={filter.value}
              type={filter.type}
              rgb={filter.rgb}
              on={filter.on}
            />
          );
        })}
      </SwatchGrid>
    </BackgroundContainer>
  );
};

FilterSwatchGrid.propTypes = {
  filterGroupData: PropTypes.object.isRequired,
  isCollapsed: PropTypes.bool,
};

export default FilterSwatchGrid;
